module.exports = __webpack_public_path__ + "img/sail.647eeebb.svg";